<template>
  <div class="carLocation">
    <div style="position: absolute;top: 0;left: 0;z-index: 2;display: flex;margin: 10px;gap:10px">


      <a-input v-model="no" style="width: 150px" placeholder="车辆编号"></a-input>


      <a-button type="primary" @click="search" :loading="loading">搜索</a-button>

      <a-select
        v-model="carIndex"
        @change="changeCar"
        show-search
        placeholder="选择车辆"
        style="width: 200px"
        :options="options">
      </a-select>


      <div>
        <a-date-picker  @change="changeDate" v-model="date" />
      </div>
      <a-button type="primary" @click="loadData" :loading="loading">查询轨迹</a-button>
      <a-button type="primary" @click="doPlay" :loading="loading">{{ playState == 0 ?'播放轨迹':(playState == 1?'暂停播放':'恢复播放') }}</a-button>
    </div>
    <div id="container" style="height: 100%"></div>
    <div class="info" v-if="p.createTime">
      <p>时间：{{ p.createTime }}</p>
      <p v-if="p.speed">当前速度：{{p.speed/10}} km/h</p>
      <p>经纬度：{{ p.lng }},{{ p.lat }}</p>
    </div>
  </div>
</template>

<script>
import AreaCascader from '@/components/select/AreaCascader'
import moment from 'moment';
import db from 'utils/localstorage'
import {WGS84_to_GCJ02} from '@/utils/common'
let convertGps = WGS84_to_GCJ02()
export default {
  components:{AreaCascader},
  name: "carLocation",
  data() {
    return {
      date: '',
      options:[],
      carIndex:'',
      loading:false,
      marker:null,
      playState:0,//0未播放，1播放中 2暂停中
      p: {},
      map: null,
      no: '',
      company:''
    }
  },
  mounted() {
    let user = db.get('USER',{})
    this.company = user.companyName || ''

    let sc = document.createElement('script')
    sc.src = 'https://webapi.amap.com/maps?v=1.4.15&key=360d4a87f559ce678b413ae9fb380be9'
    sc.type = 'text/javascript'
    sc.onload = this.onload.bind(this)
    document.body.append(sc)
    this.date = moment()
    this.no = this.$route.query.no || this.$route.params.no

  }, methods: {
    onLoaded(){

    },
    search(){
      this.playState = 0
      this.loadCarList(this.no)
      if(this.marker){
        this.marker.stopMove();
      }
    },
    changeCar(v){
      this.carIndex = v
    },
    changeDate(d,s){
      console.info(s)
    },
    loadCarList(){
      this.loading = true
      this.$post('/api/data/query_list',{
        key:'car.list2',
        company:this.company,
        no:this.no||'',
      }).then((res)=>{
        this.loading = false
        console.info(res)
        let data = res.data.data
        let i = 0
        for (const d of data) {
          d.label = d.name
          d.value = i++
        }
        this.options = data
        if(data.length == 1){
          this.carIndex = 0
          this.loadData()
        }
      }).catch((err)=>{
        this.loading = false
      })
    },
    onload() {
      this.map = new AMap.Map("container", {
        resizeEnable: true,
        center: [116.397428, 39.90923],
        zoom: 17
      });
      if (this.no) {
        this.search()
      }

    }, parseTime(now) {

      return  now.format("YYYY-MM-DD")
    },
    doPlay(){
      if(this.playState == 0){
        this.playLine()
      }else if(this.playState == 1){
        //暂停
        this.marker.pauseMove();
        this.playState = 2
      }else{
        //恢复
        this.marker.resumeMove();
        this.playState = 1
      }
    },
    playLine() {
      let that = this
      if (!this.path || this.path.length == 0) {
        this.$message.warning('请先查询')
        return
      }
      let map = this.map
      if (!this.marker) {
        this.marker = new AMap.Marker({
          map: map,
          position: [116.478935, 39.997761],
          icon: "https://webapi.amap.com/images/car.png",
          offset: new AMap.Pixel(-26, -13),
          autoRotation: true,
          angle: -90,
        });
      }
      this.marker.moveAlong(this.path, 400);

      var passedPolyline = new AMap.Polyline({
        map: map,
        // path: lineArr,
        strokeColor: "#AF5",  //线颜色
        // strokeOpacity: 1,     //线透明度
        strokeWeight: 6,      //线宽
        // strokeStyle: "solid"  //线样式
      });


      this.marker.on('moving', function (e) {
        that.p = that.points[e.passedPath.length]
        passedPolyline.setPath(e.passedPath);
      });
      this.playState = 1


    },
    query1(car){
      let date = this.parseTime(this.date)
      let startTime = date + ' 00:00:00'
      let endTime = date + ' 23:59:59'
      let that = this
      this.loading = true
      let map = this.map
      map.clearMap();
      that.$post('/api/data/query_list',{
        key: 'location.query3',
        startTime,
        endTime,
        carId: car.id
      }).then(res => {
        this.loading = false
        let data = res.data.data
        if (data.length == 0) {
          this.$message.warning('无数据')
          return
        }
        let arr = []
        let points = []
        let last = null

        for (let o of data) {
          let lngLat = convertGps.transform(o.lat, o.lng)
          o.lat = lngLat.lat
          o.lng = lngLat.lng
          if (last != null) {
            if (o.lat == last.lat && o.lng == last.lng) {
              for(let k in o ){last[k] = o[k]}
              continue
            }
          }
          last = o
          arr.push(new AMap.LngLat(o.lng, o.lat))
          points.push(o)
        }
        that.points = points
        if (false) {
          // 坐标转换
          AMap.convertFrom(arr, 'gps', function (status, result) {
            if (result.info === 'ok') {
              var path2 = result.locations;
              that.path = path2
              let polyline2 = new AMap.Polyline({
                path: path2,
                borderWeight: 20, // 线条宽度，默认为 1
                showDir: true,
                strokeColor: 'blue', // 线条颜色
                lineJoin: 'round' // 折线拐点连接处样式
              });
              map.add(polyline2);
              map.setFitView();
            }
          });

        } else {
          that.path = arr

          let polyline2 = new AMap.Polyline({
            path: arr,
            borderWeight: 20, // 线条宽度，默认为 1
            showDir: true,
            strokeColor: 'blue', // 线条颜色
            lineJoin: 'round' // 折线拐点连接处样式
          });
          map.add(polyline2);
          map.setFitView();
        }
        console.info(arr)

      })
        .catch((error) => { // 请求失败处理
          this.loading = false
          console.log(error);
        });
    },
    query2(car){
      let date = this.parseTime(this.date)
      let startTime = date + ' 00:00:00'
      let endTime = date + ' 23:59:59'
      let that = this
      this.loading = true
      let map = this.map
      map.clearMap();
      that.$post('/api/data/query_list',{
        key: 'location.query', startTime,
        endTime, no: car.no
      }).then(res => {
        this.loading = false
        let data = res.data.data
        if (data.length == 0) {
          alert('无数据')
          return
        }
        let arr = []
        let points = []
        let last = null
        let isGps = data[0].gpsType == 0
        for (let o of data) {
          if(isGps){
            let lngLat = convertGps.transform(o.lat, o.lng)
            o.lat = lngLat[0]
            o.lng = lngLat[1]
          }
          if (last != null) {
            if (o.lat == last.lat && o.lng == last.lng) {
              for(let k in o ){last[k] = o[k]}
              continue
            }
          }
          last = o
          try{
            if(!isNaN(o.lng)){
              arr.push(new AMap.LngLat(o.lng, o.lat))
              points.push(o)
            }
          }catch (err){

          }
        }
        that.points = points
        if (false) {
          // 坐标转换
          AMap.convertFrom(arr, 'gps', function (status, result) {
            if (result.info === 'ok') {
              var path2 = result.locations;
              that.path = path2
              let polyline2 = new AMap.Polyline({
                path: path2,
                borderWeight: 20, // 线条宽度，默认为 1
                showDir: true,
                strokeColor: 'blue', // 线条颜色
                lineJoin: 'round' // 折线拐点连接处样式
              });
              map.add(polyline2);
              map.setFitView();
            }
          });

        } else {
          that.path = arr

          let polyline2 = new AMap.Polyline({
            path: arr,
            borderWeight: 20, // 线条宽度，默认为 1
            showDir: true,
            strokeColor: 'blue', // 线条颜色
            lineJoin: 'round' // 折线拐点连接处样式
          });
          map.add(polyline2);
          map.setFitView();
        }
        console.info(arr)

      })
        .catch((error) => { // 请求失败处理
          this.loading = false
          console.log(error);
        });
    },
    loadData() {
      if(this.carIndex === ''){
        this.$message.warn("请选择车辆")
        return
      }
      let car = this.options[this.carIndex];
      if(car.type == 1){
        this.query1(car)
      }else{
        this.query2(car)
      }

    }
  }
}
</script>

<style scoped>
.carLocation {
  width: 100%;
  height: 100%;
  background: #fff;
  position: relative;


}
.info{
  position: absolute;
  bottom: 0;
  right: 0;
  padding:20px;
  background: #000000b0;
  color:white;
}
</style>



// WEBPACK FOOTER //
// src/views/carlocation/carLocation2.vue